import script from "./PopupReviewText.vue?vue&type=script&setup=true&lang=ts"
export * from "./PopupReviewText.vue?vue&type=script&setup=true&lang=ts"

import "./PopupReviewText.vue?vue&type=style&index=0&id=1da71de2&scoped=true&lang=scss"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1da71de2"]])

export default __exports__